import React, { useEffect } from "react";
import TkStepper from "../../atoms/TkStepper";
import { ITkKikoStepperProps } from "../../../type/componentsType/TkKikoStepper";
import { data, statusMapping } from "./parts";

/**
 * TkKikoStepperコンポーネント
 * @param {ITkKikoStepperProps} props - プロパティ
 * @param {string} props.applicationFlowType - 申請フロー種別
 * @param {string} props.businessType - 業務タイプ
 * @param {string} props.corporateApplicationClassification - 法人申請区分
 * @param {string} props.applicationStatus - 申請ステータス
 * @returns {React.FC} - TkKikoStepperコンポーネント
 */
const TkKikoStepper: React.FC<ITkKikoStepperProps> = (props) => {
  const {
    applicationFlowType,
    businessType,
    corporateApplicationClassification,
    applicationStatus,
  } = props;

  const [steps, setSteps] = React.useState<string[]>([]);
  const [activeStep, setActiveStep] = React.useState<number>(0);

  useEffect(() => {
    const index = getStepIndex(applicationStatus as string);

    if (index !== -1) {
      setActiveStep(index);
    } else {
      setActiveStep(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    applicationStatus,
    applicationFlowType,
    businessType,
    corporateApplicationClassification,
    steps,
  ]);

  useEffect(() => {
    setSteps(getStepData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationFlowType, businessType, corporateApplicationClassification]);

  const getStepData = () => {
    let useBusinessType = businessType?.toUpperCase();

    if (applicationFlowType === "TYPE5") {
      return data[7];
    }

    if (applicationStatus === "10") {
      return data[8];
    }

    if (applicationStatus === "15") {
      return data[6];
    }
    if (applicationFlowType === "TYPE3" && useBusinessType === "JOB-05") {
      if (corporateApplicationClassification === "1") {
        return data[3];
      } else {
        return data[4];
      }
    }

    if (useBusinessType === "JOB-73") {
      return data[0];
    } else if (
      (useBusinessType === "JOB-15" ||
        useBusinessType === "JOB-44" ||
        useBusinessType === "JOB-70" ||
        useBusinessType === "JOB-90") &&
      corporateApplicationClassification === "1"
    ) {
      return data[1];
    } else if (
      applicationFlowType === "TYPE1" ||
      applicationFlowType === "TYPE2"
    ) {
      return data[2];
    } else if (
      (useBusinessType === "JOB-40" ||
        useBusinessType === "JOB-74" ||
        useBusinessType === "JOB-78") &&
      corporateApplicationClassification === "1"
    ) {
      return data[3];
    } else if (applicationFlowType === "TYPE3") {
      return data[4];
    } else if (applicationFlowType === "TYPE4") {
      return data[5];
    } else {
      return [];
    }
  };

  const getStepIndex = (applicationStatus: string) => {
    const status =
      statusMapping[applicationStatus as keyof typeof statusMapping];
    return steps.findIndex((step) => step === status);
  };

  return <TkStepper steps={steps} activeStep={activeStep} />;
};

export default TkKikoStepper;
